export default {
  // LA coordinates
  latitude: 34.052235,
  longitude: -118.243683,
  telephone: '650.689.3043',
};
